import { Line } from "@models/line.model";
import { Equipment } from "@models/equipment.model";
import { InsertionCycle } from "./insertion-cycle.model";
import { PartNumberEquivalent } from "@models/partNumberEquivalent.model";
import { PartNumberRelated } from "@models/partNumberRelated.model";
import {Group} from "@app/tool/model/group.model";
import {GroupChildWrapper} from "@app/tool/model/group-child-wrapper.model";
import {isEmpty} from "lodash";
import { PartNumberStatus } from "@models/enums/part-number-status.enum";

export class PartNumber {

    public id: number;
    public name: string;
    public description: string;
    public valueStream: string;
    public sapGroup: string;
    public sapFamily: string;
    public idMMDM: number;
    public type: string;
    public ecam: string;
    public ecamVersion: string;
    public bomStatus: string;
    public status: PartNumberStatus;
    public inUse: boolean;
    public equipment: Equipment[];
    public lines: Line[];
    public insertionCycles: InsertionCycle[];
    public equivalentPartNumbers: PartNumberEquivalent[];
    public strainEquivalentPartNumbers: PartNumberEquivalent[];
    public relatedPartNumbers: PartNumberRelated[];
    public tools: any [];

    mapEquipment(equipment = []): Equipment[] {
        return equipment.map(eq => new Equipment(eq));
    }

    mapLines(lines = []): Line[] {
        return lines.map(line => new Line(line));
    }

    mapInsertionCycles(insertionCycles = []): InsertionCycle[] {
        return insertionCycles.map(insertionCycle => new InsertionCycle(insertionCycle))
    }

    mapEquivalentPartNumbers(equivalentPNs = []): PartNumberEquivalent[] {
        return equivalentPNs.map(eqPn => new PartNumberEquivalent(eqPn))
    }

    mapRelatedPartNumbers(relatedPNs = []): PartNumberRelated[] {
        return relatedPNs.map(rlPn => new PartNumberRelated(rlPn))
    }

    private mapGroups(res: any): any {
        return res.items.map(group => {
            return group.subGroup ? new Group(group) : new GroupChildWrapper(group).item;
        })
    };

    private mapStrainEquivalentPartNumbers(partNumber: any = {}): PartNumberEquivalent[] {
        const strainEquivalentPartNumbers = partNumber.strainEquivalentPartNumbers
            || partNumber.strainEquivalencePartNumbers
            || partNumber.strainEquvailencePartNumbers
            || partNumber.strainEquivalentPartnumbers
            || [];

        return this.mapEquivalentPartNumbers(strainEquivalentPartNumbers);
    }


    constructor(partNumber: any = {}) {
        this.id = partNumber.id || 0;
        this.name = partNumber.name || '';
        this.description = partNumber.description || '';
        this.valueStream = partNumber.valueStream || '';
        this.sapGroup = partNumber.sapGroup || '';
        this.sapFamily = partNumber.sapFamily || '';
        this.idMMDM = partNumber.idMMDM || 0;
        this.type = partNumber.type || '';
        this.ecam = partNumber.ecam || '';
        this.ecamVersion = partNumber.ecamVersion || '';
        this.bomStatus = partNumber.bomStatus || '';
        this.status = partNumber.status || 0;
        this.inUse = partNumber.inUse;
        this.equipment =  this.mapEquipment(partNumber.equipment || []);
        this.lines = this.mapLines(partNumber.lines || []);
        this.insertionCycles = this.mapInsertionCycles(partNumber.insertionCycles || []);
        this.equivalentPartNumbers = this.mapEquivalentPartNumbers(partNumber.equivalentPartNumbers || []);
        this.strainEquivalentPartNumbers = this.mapStrainEquivalentPartNumbers(partNumber);
        this.relatedPartNumbers = this.mapRelatedPartNumbers(partNumber.relatedPartNumbers || []);
        this.tools = !isEmpty(partNumber.tools) ? this.mapGroups(partNumber.tools) : [];
    }

    get nameWithSAP() {
        return `${this.name} ( ${this.sapGroup} - ${this.sapFamily} )`
    }

}
